import React from 'react';
import {FormattedMessage} from 'react-intl';
import {toAbsoluteUrl} from "../../../../_metronic/_helpers";

const Empty = () => (
  <div className="d-flex justify-content-center align-items-center">
    <img
      src={toAbsoluteUrl("/media/svg/Error-circle.svg")}
      alt="empty"
      className="mr-3"
    />
    <span className="font-size-h3">
      <FormattedMessage
        id="common-table-empty"
        defaultMessage='Empty...'
      />
    </span>
  </div>
);

Empty.propTypes = {};

export default Empty;
